export default {
  allMsg: 'Todos los mensajes',
  systemMsg: 'Mensajes del sistema',
  personMsg: 'Mensajes manuales',
  unread: 'No leído',
  seeDetail: 'Ver detalles',
  read: 'Leído',
  replyNow: 'Responder ahora',
  message: 'Mensaje',
  operateSuccess: 'Operación realizada con éxito',
  holder: {
    searchHolder: 'Número de paquete/Número de pedido/Número de artículo',
  },
  addAcBuy: '¡Únete al Discord de AcBuy y gana ¥2000 en efectivo! ',
  flatActivity: '🎄 Ofertas Imprescindibles de Navidad',
  joinNow1: 'Únete ahora',
  tips1: '🎁 Hasta un 80 % de Descuento',
  tips2: '🎅 Promociones Festivas por Tiempo Limitado!',
}
